// ---------------------------------------------------------------------------
// Real auth — talks to the ASP.NET Core API.
//
// Sign-in is a full browser navigation to /api/_auth/login, which redirects to
// the EBI users service; the server sets an HttpOnly cookie on the way back, so
// no credential ever lives in the browser and the cookie can't be read by
// JavaScript. All requests use `credentials: 'include'` so the browser sends
// that cookie. Calls are relative (/api/...) so they go through the Vite proxy /
// CloudFront to the API on the same origin.
//
// There is no "who am I" endpoint: because the cookie is HttpOnly, the only way
// to know whether we are signed in is to ask for something that needs auth and
// see whether it 401s. App.tsx does that with the forecast it needs anyway.
// ---------------------------------------------------------------------------

// Where to send the browser to start the OIDC flow.
// Must match Ebi.Common.Authentication.Aws.EbiAuthenticationOptions.LoginUrl.
export const LOGIN_URL = '/api/_auth/login'

// POST /api/logout — clears the cookie on the server.
// Must match EbiAuthenticationOptions.LogoutUrl.
export async function logout(): Promise<void> {
  await fetch('/api/logout', { method: 'POST', credentials: 'include' })
}
